import * as React from 'react';
import {useContext} from 'react';
import {StoreContext} from "../../stores/StoreLoader";
import SimpleAndFloating from "./SchoolBlocksHeaderThemes/SimpleAndFloating";
import MinimalTheme from "./SchoolBlocksHeaderThemes/MinimalTheme";
import {observer} from "mobx-react";
import styles from "./styles/SchoolBlocksHeader.module.scss";

const SchoolBlocksHeader: React.FC<{
    hideNavigation?: boolean,
    hideLoginButton?: boolean,
    mainUrl: string,
}> = observer(props => {
    const {styleStore, modalStore, organizationStore, interfaceStore} = useContext(StoreContext);

    function openLoginModal() {
        modalStore.addModal({
            type: 'login',
            id: 'login-modal',
        })
    }

    function toggleUserMenu() {
        const hero = document.getElementById("hero");
        const primaryNav = document.getElementById('primaryNav');
        const secondaryNav = document.getElementById('sb-secondary-nav');
        if (hero && primaryNav && secondaryNav) {
            window.scroll({
                top: hero.clientHeight - primaryNav.clientHeight - secondaryNav.clientHeight,
                behavior: "smooth",
            })
        }
        interfaceStore.toggleUserMenu();
    }

    const hideLoginButton = organizationStore.organization.json_data.settings.appearance.hideLoginButton || props.hideLoginButton;

    const theme = (styleStore.themeID === "1" || styleStore.themeID === "2" ?
        <SimpleAndFloating
            toggleUserMenu={toggleUserMenu}
            openLoginModal={openLoginModal}
            mainUrl={props.mainUrl}
            hideNavigation={props.hideNavigation}
            hideLoginButton={hideLoginButton}
        />
        :
        <MinimalTheme
            toggleUserMenu={toggleUserMenu}
            openLoginModal={openLoginModal}
            mainUrl={props.mainUrl}
            hideLoginButton={hideLoginButton}
        />
    );

    return <div className={styles.centerContent}>
        {theme}
    </div>
})

export default SchoolBlocksHeader;
